import { render, staticRenderFns } from "./NewBasePlan.vue?vue&type=template&id=cf04c1fc&"
import script from "./NewBasePlan.vue?vue&type=script&lang=js&"
export * from "./NewBasePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports